import * as React from 'react';
import { DeviceTypes } from '../../misc/api/apiTypes';
import { UploadBloodGlucoseSessionsAsyncAction } from '../UploadBloodGlucoseSessionAsyncAction';
import { UploadCoughSessionsAsyncAction } from '../UploadCoughSessionsAsyncAction';
import { DeviceOverallUploadStatus } from './DeviceOverallUploadStatus';
import { UploadDiarySessionsAsyncAction } from '../UploadDiarySessionsAsyncAction';
import { DevicesAction } from '../DevicesNewReducer';
import { useSecurityContext } from '../../Core/SecurityContext';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useDevicesStateContext } from '../DevicesStateContext';
import { useInterval } from '../../misc/Hooks/UseInterval';
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../../misc/api/WebPortalTokenClient';
import { useCoughMarshalApiClient } from '../../misc/api/CoughMarshalApiClient';
import { useAuth } from 'react-oidc-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export interface UploadProps {
    deviceType: DeviceTypes;

    dispatch: React.Dispatch<DevicesAction>;
}

export const Upload = ({ deviceType, dispatch }: UploadProps) => {
    const { currentUser } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();
    const state = useDevicesStateContext();
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const coughMarshalClient = useCoughMarshalApiClient();
    const { user } = useAuth();

    const [debouncedStatusText, setDebouncedStatusText] = React.useState(null);

    useInterval(() => setDebouncedStatusText(state.currentStatusText), 5000);

    React.useEffect(() => {
        const upload = async () => {
            switch (deviceType) {
                case DeviceTypes.StatStripXpress2:
                    await UploadBloodGlucoseSessionsAsyncAction.Upload(legacyClient, dispatch, state, user);
                    break;
                case DeviceTypes.VitaloJAK1:
                    await UploadCoughSessionsAsyncAction.UploadCoughSessions(client.client, legacyClient, coughMarshalClient, user, dispatch, state, currentUser, study.id, study.protocol);
                    break;
                case DeviceTypes.VitaloJAK2:
                    await UploadCoughSessionsAsyncAction.UploadCoughSessions(client.client, legacyClient, coughMarshalClient, user, dispatch, state, currentUser, study.id, study.protocol);
                    break;
                case DeviceTypes.In2itiveP230EDiary:
                    await UploadDiarySessionsAsyncAction.Upload(client.client, dispatch, state, study.id);
                    break;
            }
        }

        upload();
    }, [deviceType, currentUser]);

    return (
        <div>
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Upload Data</h3>
            </div>
            <div className="modal-body">
                <p style={{ fontSize: 100 + 'px' }} className="text-center text-info">
                    <FontAwesomeIcon icon={faCircleNotch} id="ConfigureStatus" className="fa-spin" aria-hidden="true" />
                </p>
                <p id="progress" className="text-center">{debouncedStatusText}</p>
            </div>
            <div className="modal-footer">
                <DeviceOverallUploadStatus
                    devices={state.selectedDevices}
                    deviceStatus={state.upload.deviceStatus}
                />
            </div>
        </div>
    );
}
